const toBool = ( v ) => {

  switch( `${ v }`.toLowerCase() ) {
    case '0':
    case 'false':
      return false
    case '1':
    case 'true':
      return true
  }
}

export default toBool
